"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulletGlyph = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const check_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/check"));
const alert_triangle_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler_filled/alert-triangle"));
const circle_dashed_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/circle-dashed"));
const CheckIcon = (props) => (React.createElement(check_1.default, { width: 16, height: 16, ...props }));
const AlertIcon = (props) => (React.createElement(alert_triangle_1.default, { width: 16, height: 16, ...props }));
const OptionalIcon = (props) => (React.createElement(circle_dashed_1.default, { width: 16, height: 16, ...props }));
const EMOJI_RE = /\p{Extended_Pictographic}/u;
const isEmoji = (s) => EMOJI_RE.test(s);
const renderChars = (chars, color, index) => {
    const trimmed = chars.slice(0, 2);
    if (!trimmed)
        return null;
    const emoji = isEmoji(trimmed);
    const single = Array.from(trimmed).length === 1;
    const fz = emoji ? (single ? 20 : 14) : single ? 18 : 14;
    void index;
    return (React.createElement("span", { style: {
            fontSize: fz,
            lineHeight: 1,
            color,
            fontWeight: 600,
            letterSpacing: 0,
            ...(emoji ? { transform: 'translateY(1px)' } : null),
        } }, trimmed));
};
const renderNumber = (index, color) => {
    const text = String(index + 1);
    return React.createElement("span", { style: { fontSize: 14, lineHeight: 1, color } }, text);
};
const BulletGlyph = ({ state, indicator, chars, index, color }) => {
    if (indicator === 'chars')
        return React.createElement(React.Fragment, null, renderChars(chars, color, index));
    if (state === 'optional')
        return React.createElement(OptionalIcon, { style: { color } });
    if (indicator === 'number')
        return React.createElement(React.Fragment, null, renderNumber(index, color));
    switch (state) {
        case 'done':
            return React.createElement(CheckIcon, { style: { color } });
        case 'warning':
        case 'error':
            return React.createElement(AlertIcon, { style: { color } });
        default:
            return React.createElement(React.Fragment, null, renderNumber(index, color));
    }
};
exports.BulletGlyph = BulletGlyph;
